import { create } from 'zustand';
import { authClient } from '../auth';

export interface AuthUser {
  id: string;
  isAnonymous: boolean;
  email: string | null;
  name: string | null;
}

interface AuthState {
  user: AuthUser | null;
  loading: boolean;
  refresh: () => Promise<void>;
  playAsGuest: () => Promise<void>;
  signOut: () => Promise<void>;
}

export const useAuth = create<AuthState>((set) => ({
  user: null,
  loading: true,

  refresh: async () => {
    const { data } = await authClient.getSession();
    set({
      user: data
        ? {
            id: data.user.id,
            isAnonymous: Boolean((data.user as { isAnonymous?: boolean }).isAnonymous),
            email: data.user.email ?? null,
            name: data.user.name ?? null,
          }
        : null,
      loading: false,
    });
  },

  /** Вход без единой формы: гость - полноценный пользователь с флагом. */
  playAsGuest: async () => {
    await authClient.signIn.anonymous();
    await useAuth.getState().refresh();
  },

  signOut: async () => {
    await authClient.signOut();
    set({ user: null });
  },
}));
